import {
    SET_MENU_USER_COMPANY
} from "@/shared/components/menu_user_company/store/types/types.js";

const mutations = { 
    [SET_MENU_USER_COMPANY]: (state, payload) => state.menu_user_company = payload,      
};

export default mutations